(function () {
  const routeAnchors = new Map([
    ['/collections/packs-fitobotanic', '#packs-fitobotanic'],
    ['/collections/suplementos-solaray-kal', '#nuestros-catalogos'],
    ['/collections/all', '#nuestros-catalogos'],
    ['/pages/objetivos-clinicos', '#objetivos-fitobotanic']
  ]);

  function scrollToHash(hash) {
    const target = document.querySelector(hash);

    if (!target) return false;

    target.scrollIntoView({ behavior: 'smooth', block: 'start' });

    if (history.pushState) {
      history.pushState(null, '', hash);
    }

    return true;
  }

  document.addEventListener('click', function (event) {
    const link = event.target.closest('a[href]');

    if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const href = link.getAttribute('href');

    if (!href || href === '#') return;

    if (href.charAt(0) === '#') {
      if (scrollToHash(href)) {
        event.preventDefault();
      }
      return;
    }

    let url;

    try {
      url = new URL(href, window.location.origin);
    } catch (error) {
      return;
    }

    if (url.origin !== window.location.origin) return;

    const mappedHash = routeAnchors.get(url.pathname);

    if (!mappedHash) return;

    if (document.querySelector(mappedHash)) {
      event.preventDefault();
      scrollToHash(mappedHash);
      return;
    }

    event.preventDefault();
    window.location.href = '/' + mappedHash;
  });

  window.addEventListener('load', function () {
    if (window.location.hash) {
      window.requestAnimationFrame(function () {
        scrollToHash(window.location.hash);
      });
    }
  });
})();
